module.exports = __webpack_public_path__ + "static/real-time-tracking-e4d679d942e792f1492850e6c0b34c46.png";